// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/search_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import { file_proto_model_system_errors } from "../model/system/errors_pb";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";
import { file_proto_model_core_paging } from "../model/core/paging_pb";
import { file_proto_model_search_search_session } from "../model/search/search_session_pb";
import { file_proto_model_search_search_result } from "../model/search/search_result_pb";
import { file_proto_model_core_sort } from "../model/core/sort_pb";

/**
 * Describes the file proto/service/search_service.proto.
 */
export const file_proto_service_search_service = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_field_mask, file_proto_model_system_errors, file_proto_model_core_model_path, file_proto_model_core_paging, file_proto_model_search_search_session, file_proto_model_search_search_result, file_proto_model_core_sort]);

/**
 * Describes the message carmen.SearchResultOptions.
 * Use `create(SearchResultOptionsSchema)` to create a new message.
 */
export const SearchResultOptionsSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 0);

/**
 * Describes the message carmen.CreateSearchSessionRequest.
 * Use `create(CreateSearchSessionRequestSchema)` to create a new message.
 */
export const CreateSearchSessionRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 1);

/**
 * Describes the message carmen.CreateSearchSessionResponse.
 * Use `create(CreateSearchSessionResponseSchema)` to create a new message.
 */
export const CreateSearchSessionResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 2);

/**
 * Describes the message carmen.GetSearchSessionRequest.
 * Use `create(GetSearchSessionRequestSchema)` to create a new message.
 */
export const GetSearchSessionRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 3);

/**
 * Describes the message carmen.GetSearchSessionResponse.
 * Use `create(GetSearchSessionResponseSchema)` to create a new message.
 */
export const GetSearchSessionResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 4);

/**
 * Describes the message carmen.ListSearchSessionsRequest.
 * Use `create(ListSearchSessionsRequestSchema)` to create a new message.
 */
export const ListSearchSessionsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 5);

/**
 * Describes the message carmen.ListSearchSessionsResponse.
 * Use `create(ListSearchSessionsResponseSchema)` to create a new message.
 */
export const ListSearchSessionsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 6);

/**
 * Describes the message carmen.ListSearchResultsRequest.
 * Use `create(ListSearchResultsRequestSchema)` to create a new message.
 */
export const ListSearchResultsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 7);

/**
 * Describes the message carmen.ListSearchResultsResponse.
 * Use `create(ListSearchResultsResponseSchema)` to create a new message.
 */
export const ListSearchResultsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 8);

/**
 * Describes the message carmen.RefreshSearchResultsRequest.
 * Use `create(RefreshSearchResultsRequestSchema)` to create a new message.
 */
export const RefreshSearchResultsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 9);

/**
 * Describes the message carmen.RefreshSearchResultsResponse.
 * Use `create(RefreshSearchResultsResponseSchema)` to create a new message.
 */
export const RefreshSearchResultsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 10);

/**
 * Describes the message carmen.DeleteSearchSessionRequest.
 * Use `create(DeleteSearchSessionRequestSchema)` to create a new message.
 */
export const DeleteSearchSessionRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 11);

/**
 * Describes the message carmen.DeleteSearchSessionResponse.
 * Use `create(DeleteSearchSessionResponseSchema)` to create a new message.
 */
export const DeleteSearchSessionResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 12);

/**
 * Describes the message carmen.UpdateSearchSessionRequest.
 * Use `create(UpdateSearchSessionRequestSchema)` to create a new message.
 */
export const UpdateSearchSessionRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 13);

/**
 * Describes the message carmen.UpdateSearchSessionResponse.
 * Use `create(UpdateSearchSessionResponseSchema)` to create a new message.
 */
export const UpdateSearchSessionResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_search_service, 14);

/**
 * Service for managing search sessions and search results.
 *
 * @generated from service carmen.SearchService
 */
export const SearchService = /*@__PURE__*/
  serviceDesc(file_proto_service_search_service, 0);

